// Portfolio embed: halaman admin bisa dibuka untuk semua user yang login
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext.jsx";
import { BOOKING_BASE } from "../constants.js";

export default function RequireAdmin({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return <Navigate to={`${BOOKING_BASE}/login`} state={{ from: location }} replace />;
  return children;
}
